import React from "react";
import { Helmet } from "react-helmet";
import { isNilOrEmpty, useSessionCtx } from "utils";

// Helmet does not support an onLoad callback for scripts
// https://github.com/nfl/react-helmet/issues/146#issuecomment-271552211
export const ScriptLoader = ({ scriptUrl, onLoaded }) => {
  const { debug } = useSessionCtx();
  if (isNilOrEmpty(scriptUrl)) {
    debug("ScriptLoader WARNING: no scriptUrl!");
    onLoaded(true);
    return null;
  }
  const handleScriptInject = ({ scriptTags }) => {
    /* istanbul ignore if */
    if (scriptTags) {
      const scriptTag = scriptTags[0];
      debug("ScriptLoader::scriptTag", scriptUrl, scriptTag);
      scriptTag.onload = (e) => {
        debug("ScriptLoader::loaded", scriptUrl, scriptTag, e);
        onLoaded(true);
      };
    }
  };
  return (
    <Helmet
      script={[{ src: scriptUrl }]}
      onChangeClientState={(newState, addedTags) => handleScriptInject(addedTags)}
    />
  );
};
